import React, { useRef } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useRecipeCreation } from '../../../context/RecipeCreationContext';
import TextareaWithLabel from '../../common/TextareaWithLabel';

const AddOnsTab = ({ isView }) => {
  const { recipeData, updateRecipeData } = useRecipeCreation();
  const fileInputRef = useRef(null);

  const handleChefsNoteChange = (e) => {
    updateRecipeData({ chefs_note: e.target.value });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      // Create preview URL
      const previewUrl = URL.createObjectURL(file);
      updateRecipeData({
        cover_image: file,
        cover_image_preview: previewUrl
      });
    }
  };

  const handleRemoveImage = () => {
    if (recipeData.cover_image_preview) {
      URL.revokeObjectURL(recipeData.cover_image_preview);
    }
    updateRecipeData({
      cover_image: null,
      cover_image_preview: null
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleImageClick = () => {
    if (!isView) {
      fileInputRef.current?.click();
    }
  };

  return (
    <div className="space-y-6">
      {/* Addition Notes Section */}
      <div className="bg-white dark:bg-shoorah-darkBgTabColor rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
          Addition Notes (Optional)
        </h3>

        <TextareaWithLabel
          label="Chefs Note"
          placeholder="e.g. A fast-paced, full-body routine that pushes you to your limits with intense bursts of exercise and minimal rest, maximising calorie burn and boosting fitness in a short time."
          value={recipeData.chefs_note || ''}
          onChange={handleChefsNoteChange}
          name="chefs_note"
          id="chefs_note"
          disabled={isView}
          rows={5}
          labelClassName="text-sm font-medium text-gray-700 dark:text-shoorah-darkBg"
          errorMargin="mt-1"
          labelMargin="mb-1"
          errorSize="text-[12px]"
        />
      </div>

      {/* Cover Image Section */}
      <div className="bg-white dark:bg-shoorah-darkBgTabColor rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
          Add Cover Image
        </h3>

        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          disabled={isView}
          className="hidden"
        />

        {recipeData.cover_image_preview || recipeData.cover_image ? (
          <div className="relative inline-block">
            <img
              src={recipeData.cover_image_preview || recipeData.cover_image}
              alt="Recipe cover"
              className="w-80 h-56 object-cover rounded-lg cursor-pointer"
              onClick={handleImageClick}
            />
            {!isView && (
              <button
                type="button"
                onClick={handleRemoveImage}
                className="absolute top-2 right-2 p-1.5 bg-red-600 hover:bg-red-700 text-white rounded-full shadow-lg transition-colors"
                title="Remove image"
              >
                <XMarkIcon className="h-5 w-5" />
              </button>
            )}
          </div>
        ) : (
          <button
            type="button"
            onClick={handleImageClick}
            disabled={isView}
            className="w-80 h-56 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg flex flex-col items-center justify-center hover:border-shoorah-primary hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
          >
            <svg
              className="w-12 h-12 text-gray-400 mb-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <p className="text-sm text-gray-500 dark:text-gray-400">Click to upload cover image</p>
            <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">PNG, JPG up to 10MB</p>
          </button>
        )}
      </div>
    </div>
  );
};

export default AddOnsTab;
